/** US English and Spanish Standard voices supported by Twilio: https://www.twilio.com/docs/voice/twiml/say/text-speech */
export const AUTOMATED_VOICE_GOOGLE_VOICES = [
    {
        id: 'Google.en-US-Standard-A',
        label: 'Google A · English (US) · Male',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-B',
        label: 'Google B · English (US) · Male',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-C',
        label: 'Google C · English (US) · Female',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-D',
        label: 'Google D · English (US) · Male',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-E',
        label: 'Google E · English (US) · Female',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-F',
        label: 'Google F · English (US) · Female',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-G',
        label: 'Google G · English (US) · Female',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-H',
        label: 'Google H · English (US) · Female',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-I',
        label: 'Google I · English (US) · Male',
        locale: 'en-US',
    },
    {
        id: 'Google.en-US-Standard-J',
        label: 'Google J · English (US) · Male',
        locale: 'en-US',
    },
    {
        id: 'Google.es-US-Standard-A',
        label: 'Google A · Spanish (US) · Female',
        locale: 'es-US',
    },
    {
        id: 'Google.es-US-Standard-B',
        label: 'Google B · Spanish (US) · Male',
        locale: 'es-US',
    },
    {
        id: 'Google.es-US-Standard-C',
        label: 'Google C · Spanish (US) · Male',
        locale: 'es-US',
    },
];
//# sourceMappingURL=googleVoices.js.map